import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { createUseStyles } from 'react-jss'
import withTheme from '../styles/withTheme'

const styles = {
	modalActions: {
		padding: props => props.size === 'fullWidth' ? '0.5rem 3.75rem' : '1.063rem 3.75rem',
		borderTop: '2px solid',
		borderTopColor: props => props.theme === 'dark' ? '#ddd9d2' : '#8994a5',
		justifyContent: 'space-between',
		flex: '0 0 auto',
		'@media (max-width: 575px)': {
			paddingLeft: '1rem',
			paddingRight: '1rem'
		}
	}
}

const useStyles = createUseStyles(styles, { name: 'Vb' })

const ModalActions = forwardRef(function ModalActions(props, ref) {
	const { children, className, ...other } = props

	const classes = useStyles(props)

	return (
		<div ref={ref} className={clsx(classes.modalActions, className)} {...other}>
			{children}
		</div>
	)
})

export default withTheme('Vb-modal-actions')(ModalActions)

ModalActions.propTypes = {
	/**
	 * Modal children, usually the included sub-components.
	 */
	children: PropTypes.node
}
